import React from "react";
import {
  Image,
  Page,
  Document,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import styled from "styled-components";
import Encabezado from "./assets/encabezado.png";
import Firma from "./assets/firma.png";
import { EstiloButton } from "./App";
import MoonLoader from "react-spinners/MoonLoader";
import { BotonGenerarPDF } from "./FirestoreTableContrato";

const ContenedorLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
const SpinnerContainerLoading = styled.div`
  width: auto;
  display: flex;
  margin-top: 10px;
`;

const SpinnerTexto = styled.div`
  font-weight: bold;
`;
const StyledPDFDownloadLink = styled(PDFDownloadLink)`
  text-decoration: none;
  color: gray;
`;

const styles = StyleSheet.create({
  page: {
    position: "relative",
    fontSize: 9,
    flexDirection: "column",
  },
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
  },
  section: {
    margin: 8,
  },
  header: {
    fontSize: 14,
    marginTop: 60,
    marginBottom: 8,
    marginLeft: 20,
    marginRight: 20,
  },
  empresa: {
    fontSize: 10,
    marginBottom: 8,
    marginLeft: 20,
    marginRight: 20,
  },
  field: {
    marginBottom: 8,
    marginLeft: 20,
    marginRight: 20,
  },
  texto: {
    marginBottom: 2,
    marginLeft: 20,
    marginRight: 20,
    fontSize: 7,
    textAlign: "justify",
  },
  linea: {
    backgroundColor: "#000000",
    width: "100%",
    height: 0.5,
    marginBottom: 2,
  },
  firma: {
    position: "absolute",
    bottom: 30,
    right: 30,
    width: 100,
  },
});

const VoucherPDF = ({ voucherData, pdfVisible }) => {
  /// Lógica para generar el nombre del archivo PDF
  const nombreArchivo = voucherData.nombre
    ? `Voucher ${voucherData.apellido} ${voucherData.nombre}.pdf`
    : "Voucher.pdf";

  const generatePDF = () => (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.backgroundImage}>
          <Image src={Encabezado} style={styles.backgroundImage} />
        </View>
        <View style={styles.section}>
          <Text style={styles.header}>Voucher de Viaje</Text>
          <View style={styles.empresa}>
            <Text>
              CATA Internacional L.T.D.A. / CUIT Nº 33-54662883-9 / EVyT
              Leg.10.755
            </Text>
          </View>
          <View style={styles.field}>
            <Text>Código de Voucher: {voucherData.voucherNumero}</Text>
          </View>
          <View style={styles.field}>
            <Text>
              Nombre: {voucherData.apellido}, {voucherData.nombre}- DNI:{" "}
              {voucherData.dni} - Fecha de Nacimiento:{" "}
              {new Date(
                new Date(voucherData.fechaNacimiento).toLocaleString("en-US", {
                  timeZone: "UTC",
                })
              ).toLocaleDateString("es-ES")} - Email: {voucherData.email}
            </Text>
          </View>
          <View style={styles.field}>
            <Text>
              Fecha de Salida:{" "}
              {new Date(
                new Date(voucherData.fechaSalida).toLocaleString("en-US", {
                  timeZone: "UTC",
                })
              ).toLocaleDateString("es-ES")}{" "}
              Hora: {voucherData.horaSalida}
            </Text>
          </View>
          <View style={styles.field}>
            <Text>Origen: {voucherData.origen}</Text>
          </View>
          <View style={styles.field}>
            <Text>
              Destino: {voucherData.destino} - Fecha de Regreso:{" "}
              {voucherData.fechaRegreso ? (
                <>
                  {new Date(
                    new Date(voucherData.fechaRegreso).toLocaleString("en-US", {
                      timeZone: "UTC",
                    })
                  ).toLocaleDateString("es-ES")}{" "}
                  Hora: {voucherData.horaRegreso}
                </>
              ) : (
                "Solo traslado de ida"
              )}
              {" - Observaciones: "}
              {voucherData.observaciones}
            </Text>
          </View>
          <View style={styles.linea}></View>
          <View style={styles.texto}>
            <Text>
              REGLAMENTO DE PASAJERO: La adquisición de este voucher implica
              total conocimiento y aceptación de las condiciones abajo
              especificadas, de acuerdo a las disposiciones legales y
              reglamentarias vigentes, a saber: 1- Por razones de seguridad no
              pueden transportarse elementos que de algún modo pongan en peligro
              la seguridad del vehículo, el pasaje transportado o el personal de
              la empresa. 2- La Empresa no se hace responsable por gastos o
              perjuicios, provocados por la demora en la salida, llegada y/o
              interrupciones durante el viaje, cuando ello se deba a caso
              fortuito o fuerza mayor. 3- La Empresa se reserva el derecho de
              hacer que el pasajero abandone el viaje en cualquier tramo del
              recorrido, por cualquier motivo que constituya peligro o molestia
              para los restantes pasajeros o el personal, debiendo dejarlo a
              resguardo de la autoridad y/o en lugar seguro. 4- Es
              responsabilidad del pasajero, consultar y cumplir las
              disposiciones aduaneras, sanitarias, fitosanitarias y de
              migraciones. Cualquier infracción a las normas será de su absoluta
              responsabilidad. 5- DOCUMENTOS: En los servicios internacionales,
              el pasajero deberá satisfacer toda las exigencias gubernamentales
              en materia de Documentos Personales exigidos para viajar, tanto en
              la salida como en la entrada de ambos países. La empresa no se
              responsabiliza por los gastos e inconvenientes ocasionados por el
              incumplimiento por parte del pasajero de esas exigencias. Este es
              un documento sin valor, solo válido para el servicio contratado.
            </Text>
          </View>
          <View style={styles.linea}></View>
        </View>

        {voucherData.estadia && (
          <>
            <View style={styles.page}>
              <View style={styles.backgroundImage}>
                <Image src={Encabezado} style={styles.backgroundImage} />
              </View>
              <View style={styles.section}>
                <Text style={styles.header}>Voucher Estadía</Text>
                <View style={styles.empresa}>
                  <Text>
                    CATA Internacional L.T.D.A. / CUIT Nº 33-54662883-9 / EVyT
                    Leg.10.755
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>Código de Voucher: {voucherData.voucherNumero}</Text>
                </View>
                <View style={styles.field}>
                  <Text>
                    Nombre: {voucherData.apellido}, {voucherData.nombre} - DNI:{" "}
                    {voucherData.dni} - Pasajeros: {voucherData.pasajeros}
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>Estadía: {voucherData.estadia}</Text>
                </View>
                <View style={styles.field}>
                  <Text>
                    Dirección: {voucherData.direccionEstadia} - Telefono:{" "}
                    {voucherData.contactoEstadia}
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>
                    Alojamiento: {voucherData.alojamiento} - Habitación:{" "}
                    {voucherData.habitacion}
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>
                    In:{" "}
                    {new Date(
                      new Date(voucherData.inEstadia).toLocaleString("en-US", {
                        timeZone: "UTC",
                      })
                    ).toLocaleDateString("es-ES")}{" "}
                    - Out:{" "}
                    {new Date(
                      new Date(voucherData.outEstadia).toLocaleString("en-US", {
                        timeZone: "UTC",
                      })
                    ).toLocaleDateString("es-ES")}
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>
                    Check In: {voucherData.checkIn} hs. - Check Out:{" "}
                    {voucherData.checkOut} hs.
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>Observaciones: {voucherData.observacionesEstadia}</Text>
                </View>
                <Image src={Firma} style={styles.firma} />
                <View style={styles.linea}></View>
                <View style={styles.texto}>
                  <Text>
                    ESTOS SERVICIOS SERAN PAGADOS POR: CATA TURISMO - 0261
                    4380100
                  </Text>
                </View>
                <View style={styles.linea}></View>
              </View>
            </View>
          </>
        )}
        {voucherData.servicio && (
          <>
            <View style={styles.page}>
              <View style={styles.backgroundImage}>
                <Image src={Encabezado} style={styles.backgroundImage} />
              </View>
              <View style={styles.section}>
                <Text style={styles.header}>Voucher Transfer</Text>
                <View style={styles.empresa}>
                  <Text>
                    CATA Internacional L.T.D.A. / CUIT Nº 33-54662883-9 / EVyT
                    Leg.10.755
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>Código de Voucher: {voucherData.voucherNumero}</Text>
                </View>
                <View style={styles.field}>
                  <Text>
                    Nombre: {voucherData.apellido}, {voucherData.nombre} - DNI:{" "}
                    {voucherData.dni} - Pasajeros: {voucherData.pasajeros}
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>Servicio: {voucherData.servicio}</Text>
                </View>
                <View style={styles.field}>
                  <Text>
                    Dirección: {voucherData.direccionServicio} - Telefono:{" "}
                    {voucherData.contactoServicio}
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>
                    Trfr In: {voucherData.trfrIn} - Trfr Out:{" "}
                    {voucherData.trfrIn}
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text>Servicio Adicional: {voucherData.tipoDeServicio}</Text>
                </View>
                <View style={styles.field}>
                  <Text>DIA Y HORARIO A CONFIRMAR EN DESTINO</Text>
                </View>
                <View style={styles.field}>
                  <Text>
                    Observaciones: {voucherData.observacionesServicio}
                  </Text>
                </View>
                <Image src={Firma} style={styles.firma} />
                <View style={styles.linea}></View>
                <View style={styles.texto}>
                  <Text>
                    ESTOS SERVICIOS SERAN PAGADOS POR: CATA TURISMO - 0261
                    4380100
                  </Text>
                </View>
                <View style={styles.linea}></View>
              </View>
            </View>
          </>
        )}
      </Page>
    </Document>
  );

  return (
    <div>
      <StyledPDFDownloadLink document={generatePDF()} fileName={nombreArchivo}>
        {({ blob, url, loading, error }) => (
          <ContenedorLoading>
            {loading ? (
              <>
                <SpinnerContainerLoading>
                  <MoonLoader color="#c20000" size={pdfVisible ? 20 : 50} />
                </SpinnerContainerLoading>
                {!pdfVisible && <SpinnerTexto>Generando PDF...</SpinnerTexto>}
              </>
            ) : pdfVisible ? (
              <BotonGenerarPDF>Descargar</BotonGenerarPDF>
            ) : (
              <EstiloButton>
                Descargar Voucher {voucherData.nombre}
              </EstiloButton>
            )}
          </ContenedorLoading>
        )}
      </StyledPDFDownloadLink>
    </div>
  );
};

export default VoucherPDF;
